module.exports = __webpack_public_path__ + "static/media/GetMetamask.e16c8640.png";